import { API_URL } from "@/mainconfig";

const state = {
    paymentData: JSON.parse(sessionStorage.getItem("paymentData")) || null,
    paymentMethods: [],
    error: null,
    errorMessage: null,
    loading: false,
    paymentStatus: null,
};

const getters = {
    isLoading: (state) => state.loading,
    getPaymentData: (state) => state.paymentData,
    getPaymentMethods: (state) => state.paymentMethods,
    getPaymentStatus: (state) => state.paymentStatus,
    getPaymentError: (state) => state.errorMessage,
};

const actions = {
    savePaymentData({ commit }, payload) {
        commit("setPaymentData", payload);
    },

    async fetchReceipt({ commit }, bookingCode) {
        commit("setLoading", true);
        try {
            const response = await API_URL.get(
                `/payment/receipts/${bookingCode}`
            );
            commit("setError", null); // Bersihkan error jika berhasil
            return response.data.url; // Asumsikan backend mengembalikan URL file
        } catch (error) {
            console.error("Error fetching receipt:", error);
            commit(
                "setError",
                error.response?.data?.msg || "Failed to fetch receipt."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    async fetchPaymentMethods({ commit }, ownerId) {
        commit("setLoading", true);
        try {
            const response = await API_URL.get(
                `/payment-method/getAllActiveByOwner/${ownerId}`
            );
            commit("setPaymentMethods", response.data); // Update state dengan data dari API
            return response.data;
        } catch (error) {
            commit(
                "setError",
                error.response?.data?.msg || "Failed to fetch payment methods."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    async processPayment({ commit }, payload) {
        commit("setLoading", true);
        try {
            const response = await API_URL.post("/payment/process", payload);
            commit("setPaymentStatus", "success");
            commit("setError", null);
            return response;
        } catch (error) {
            commit("setPaymentStatus", "failed");
            commit(
                "setError",
                error.response?.data?.msg ||
                    "An error occurred during payment processing."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    async processCheckout({ commit }, payload) {
        commit("setLoading", true);

        console.log("Payload di Vuex Action:", payload); // Debugging payload di Vuex Action

        try {
            const response = await API_URL.post("/booking/checkout", payload);
            commit("setPaymentStatus", "success");
            commit("setError", null);
            if (response.status === 200 && response.data?.code === 0) {
                console.log(
                    "Checkout berhasil, menghapus roomCart dari localStorage."
                );
                localStorage.removeItem("roomCart"); // Hapus roomCart dari localStorage
            }

            console.log("response", response);
            return response.data; // Kembalikan hasil response jika diperlukan
        } catch (error) {
            commit("setPaymentStatus", "failed");
            commit(
                "setError",
                error.response?.data?.msg || "Failed to process checkout."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    clearPaymentData({ commit }) {
        commit("clearPaymentData");
    },
};

const mutations = {
    setPaymentData(state, payload) {
        console.log(
            "Mutation setPaymentData dijalankan dengan payload:",
            payload
        );

        state.paymentData = payload;

        // Simpan ke localStorage (opsional jika ingin persist data di refresh)
        sessionStorage.setItem("paymentData", JSON.stringify(payload));
    },
    setPaymentMethods(state, methods) {
        state.paymentMethods = methods;
    },
    clearPaymentData(state) {
        state.paymentData = null;
        state.paymentStatus = null;
        localStorage.removeItem("paymentData");
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setPaymentStatus(state, status) {
        state.paymentStatus = status;
    },
    setError(state, error) {
        state.error = error;
        state.errorMessage = error || "An error occurred.";
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
